<div class="mb-4 d-flex-between">
  <div class="d-grid">
    <h3 class="mb-0">{{ "mobile-status.mobile-worklist.title" | translate }}</h3>
    <p>{{ "mobile-status.mobile-worklist.info" | translate }}</p>
  </div>
  <div class="d-flex align-items-center">
    <a class="btn btn-warning ms-2" (click)="filterCollaps = !filterCollaps">
      {{ "general.filter" | translate }}
    </a>
    <button type="button" class="btn btn-primary ms-2" (click)="initilize()">
      {{ "mobile-status.mobile-worklist.create" | translate }}
    </button>
  </div>
</div>
<div class="row">
  <div class="col-xl-12 active-p">
    <div class="filter cm-content-box box-primary" *ngIf="filterCollaps">
      <div class="content-title">
        <div class="cpa">
          <i class="fa-sharp fa-solid fa-filter me-2"></i>{{ "general.filter" | translate }}
        </div>
      </div>

      <div class="cm-content-body form excerpt">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-3 col-sm-6">
              <label for="">{{ "mobile-status.mobile-worklist.search" | translate }}</label>
              <input type="search" class="form-control mb-xl-0 mb-3"
                [placeholder]="'mobile-status.mobile-worklist.searchPlaceholder' | translate" aria-controls="user-tbl"
                [(ngModel)]="filter.search" />
            </div>

            <div class="col-xl-3 col-sm-6 mb-3">
              <label for="">{{ "mobile-status.mobile-worklist.startDate" | translate }}</label>
              <p-calendar [(ngModel)]="filter.startDate" [placeholder]="'mobile-status.mobile-worklist.datePlaceHolder' | translate"
                [showTime]="false" [showButtonBar]="true" appendTo="body" #filterDate />
            </div>
            <div class="col-xl-3 col-sm-6 mb-3">
              <label for="">{{ "mobile-status.mobile-worklist.endDate" | translate }}</label>
              <p-calendar [(ngModel)]="filter.endDate" [placeholder]="'mobile-status.mobile-worklist.datePlaceHolder' | translate"
                [showTime]="false" [showButtonBar]="true" appendTo="body" #filterDate />
            </div>
            <div class="col-xl-3 col-sm-6 mb-3">
              <label for="">{{ "mobile-status.mobile-worklist.team" | translate }}</label>

              <p-multiSelect [options]="teamsOptions" [placeholder]="'mobile-status.mobile-worklist.team' | translate "
                [(ngModel)]="filter.teamIds" optionLabel="label" optionValue="value" appendTo="body"></p-multiSelect>
            </div>
            <div class="col-12 d-flex justify-content-end mt-3">
              <button class="btn btn-danger light" (click)="clearFilter()" type="button">
                {{ "general.clear-filter" | translate }}
              </button>
              <button class="btn btn-info ms-2" type="button" (click)="getFilteredList(filter)">
                {{ "general.filtering" | translate }}
                <i class="fa fa-search ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-12 active-p">
    <div class="card">
      <div class="card-body p-0">
        <div class="table-responsive active-projects style-1">
          <div class="tbl-caption">
            <h4 class="heading mb-0">
              {{ "mobile-status.mobile-worklist.title" | translate }}

            </h4>
          </div>
          <p-table [rowHover]="true" responsiveLayout="stack" [rows]="rows" [first]="first" [totalRecords]="data.length"
            paginatorDropdownAppendTo="body" [value]="data" [paginator]="true" [rowsPerPageOptions]="[10, 20, 30]">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.id" | translate }}
                  </span>
                </th>
                <th scope="col" pSortableColumn="first_name" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.workTitle" | translate }}
                  </span>
                </th>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.description" | translate }}
                  </span>
                </th>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.date" | translate }}
                  </span>

                </th>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.status" | translate }}
                  </span>
                </th>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.teams" | translate }}
                  </span>
                </th>
                <th scope="col" style="font-weight: bold;">
                  <span class="p-column-title">
                    {{ "mobile-status.mobile-worklist.priority" | translate }}
                  </span>
                </th>
                <th scope="col" style="font-weight: bold;">

                </th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-list>
              <tr>
                <td>{{ list?.id }}</td>
                <td>{{ list?.title }}</td>
                <td>{{ list?.description }}</td>
                <td>{{ list?.workDate| date: 'dd.MM.yyyy HH:mm' }}</td>
                <td>{{ list?.statusName }}</td>
                <td>{{ list?.teamNames?.join(', ') }}</td>
                <td>{{ list?.priorityName }}</td>
                <td>
                  <i class="pi pi-pencil edit-history-action-icon" (click)="openUpdateModal(list)"></i>
                  <i class="pi pi-history edit-history-action-icon" (click)="openStatusHistoryModal(list)"></i>
                </td>

              </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
              {{ data.length }} {{ "common.table.totalFound" | translate }}
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="99">{{ "common.noData" | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="statusLogsVisible" modal [header]="'mobile-status.mobile-worklist.statusHistory' | translate" [style]="{ width: '60vw' }">
  <div class="status-history-container">
    <p-timeline [value]="statusLogs" align="alternate" styleClass="customized-timeline">
      <ng-template pTemplate="marker" let-statusLog>
        <span class="custom-marker">
          <i class="pi pi-circle-fill"></i>
        </span>
      </ng-template>
      
      <ng-template pTemplate="content" let-statusLog>
        <div class="timeline-content">
          <div class="status-change">
            <span class="old-status">{{ statusLog.oldStatusName }}</span>
            <i class="pi pi-arrow-right mx-2"></i>
            <span class="new-status" >
              {{ statusLog.newStatusName }}
            </span>
          </div>
          <div class="change-details">
            <div class="user-info">
              <i class="pi pi-user"></i>
              <span> <b>{{'mobile-status.mobile-worklist.processUser' | translate}} </b>{{ statusLog.user?.name }}</span>
            </div>
            <div class="date-info">
              <i class="pi pi-calendar"></i>
              <span><b>{{'mobile-status.mobile-worklist.processDate' | translate}} </b> {{ statusLog.changedAt | date: 'dd.MM.yyyy HH:mm' }}</span>
            </div>
          </div>
          <div class="change-note" *ngIf="statusLog.note">
            <i class="pi pi-comment"></i>
            <span>{{ statusLog.note }}</span>
          </div>
        </div>
      </ng-template>
    </p-timeline>
    
    <div class="no-history" *ngIf="!statusLogs ?? statusLogs.length === 0">
      <i class="pi pi-info-circle"></i>
      <span>{{'mobile-status.mobile-worklist.nonStatusHistory' | translate}}</span>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-secondary" (click)="closeStatusLogsDialog()">
      {{'mobile-status.mobile-worklist.close' | translate}}
    </button>
  </ng-template>
</p-dialog>


<app-worklist-create [(visible)]="showCreateModal" (workCreated)="onWorkCreated($event)"></app-worklist-create>

<app-worklist-update [(visible)]="showUpdateModal" [work]="selectedWork"  (workUpdated)="onWorkUpdated($event)">
</app-worklist-update>

